<div class="lmo-frac-fcpo-add">
  <form [formGroup]="nonPoDataForm" class="new-orders-form">
    <mat-form-field>
      <mat-label>Select Mesh*</mat-label>
      <mat-select formControlName="meshId" saAutomatedSelector="fcpo_add__mesh_selector">
        <mat-optgroup *ngFor="let group of meshesInGroup$ | async" [label]="group.meshName">
          <mat-option *ngFor="let mesh of group.meshes" [value]="mesh.id">
            {{ mesh.type }}
            <span *ngIf="!mesh.isSupplemental; else isSupplementalMesh">
              Mesh
            </span>
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <div class="contract-container">
      <mat-form-field>
        <mat-label>Loading Facility</mat-label>
        <mat-select formControlName="mine" saAutomatedSelector="fcpo_add__loader_selector">
          <mat-optgroup label="Contracted Loaders">
            <mat-option *ngFor="let mine of fracMines$$ | async; trackBy: trackById" [value]="mine">
              <span class="name">{{ mine.site.name }}</span>
              <span class="in-use" *ngIf="mine.inUse"> (In Use)</span>
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
      <button
        type="button"
        color="primary"
        mat-mini-fab
        (click)="addNewLoader()"
        [disabled]="nonPoDataForm.get('meshId').invalid"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <div class="contract-container">
      <mat-form-field>
        <mat-label>Purchase Order</mat-label>
        <mat-select formControlName="purchaseOrder" saAutomatedSelector="fcpo_add__purchase_order_selector">
          <mat-select-trigger>
            {{ nonPoDataForm.get('purchaseOrder').value ? nonPoDataForm.get('purchaseOrder').value.name : 'Select' }}
          </mat-select-trigger>
          <mat-option *ngFor="let po of meshPos$$ | async; trackBy: trackById" [value]="po">
            <div class="po-container">
              <div class="po-header">
                <span class="name">{{ po.name }}</span>
                <span class="opened-date">Opened {{ po.createdTimestamp | date: 'shortDate' }}</span>
              </div>
              <div class="po-body">{{ floor(calculatePoRemaining(po) / 2000) | number: '1.0-0' }} tons remaining</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button
        type="button"
        color="primary"
        mat-mini-fab
        (click)="startNewPo()"
        [disabled]="nonPoDataForm.get('mine').invalid || nonPoDataForm.get('mine').disabled"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </form>
  <form
    [formGroup]="editPoForm"
    class="new-orders-form"
    (ngSubmit)="addFcpo()"
    *ngIf="editPoForm.enabled"
    [@slideInAndOut]
  >
    <h3>Details</h3>
    <mat-form-field class="form-field">
      <input
        matInput
        placeholder="Total Tonnage"
        formControlName="totalTonnage"
        autocomplete="off"
        sa-number-input
        saAutomatedSelector="fcpo_add__total_tonnage"
      />
    </mat-form-field>
    <div class="form-row">
      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Daily Min (Tons)"
          formControlName="dailyMinTon"
          autocomplete="off"
          sa-number-input
          saAutomatedSelector="fcpo_add__daily_min"
        />
      </mat-form-field>
      <div class="spacer"></div>
      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Daily Max (Tons)"
          formControlName="dailyMaxTon"
          autocomplete="off"
          sa-number-input
          saAutomatedSelector="fcpo_add__daily_max"
        />
      </mat-form-field>
    </div>
    <mat-form-field class="form-field">
      <input
        matInput
        placeholder="Cost Per Ton"
        formControlName="costPerTon"
        autocomplete="off"
        saCurrencyInput
        saAutomatedSelector="fcpo_add__cost"
      />
    </mat-form-field>
    <mat-form-field class="form-field">
      <input
        matInput
        class="datepicker-input"
        placeholder="Reset daily allocation time"
        autocomplete="off"
        formControlName="resetAllocationTime"
        [owlDateTime]="resetAllocationTime"
        [owlDateTimeTrigger]="resetAllocationTime"
      />
      <owl-date-time #resetAllocationTime [pickerType]="'timer'"></owl-date-time>
    </mat-form-field>
    <mat-form-field class="form-field">
      <input
        matInput
        placeholder="Billable Mileage"
        [formControl]="nonPoDataForm.get('billableMileage')"
        autocomplete="off"
        type="number"
        saAutomatedSelector="fcpo_add__billable_mileage"
        min="0"
      />
      <mat-hint *ngIf="billableMileage$ | async as billableMileage"
        >SANDi recommends setting billable mileage to {{ billableMileage | i18nPlural: milePluralMapping }}.</mat-hint
      >
    </mat-form-field>
    <mat-form-field class="form-field" *saFeatureFlag="'defaultLoadWeightInput'">
      <input
        matInput
        placeholder="Default Load Weight"
        [formControl]="nonPoDataForm.get('defaultLoadWeight')"
        autocomplete="off"
        sa-number-input
      />
      <mat-hint
        >Most of the time this should be left blank. This is used when city/state/county regulations require running
        lighter loads (Due to Frost Laws, Spring melt, etc)</mat-hint
      >
    </mat-form-field>
    <div class="h-2"></div>
    <mat-form-field class="form-field">
      <input
        matInput
        placeholder="PO Line Item Number"
        [formControl]="nonPoDataForm.get('poLineItemNumber')"
        [required]="isPOLineItemNumberMandatory"
        autocomplete="off"
        type="text"
        saAutomatedSelector="fcpo_add__poLineItemNumber"
      />
    </mat-form-field>

    <mat-form-field class="form-field">
      <input
        matInput
        placeholder="Percent Based Allocation"
        [formControl]="nonPoDataForm.get('percentBasedAutoOrderingAllocation')"
        autocomplete="off"
        type="text"
        min="0"
        sa-number-input
      />
    </mat-form-field>

    <mat-form-field class="form-field subscribed-users" *saFeatureFlag="'purchaseOrderAllocationNotifications'">
      <mat-select
        formControlName="subscribedSandiUsers"
        placeholder="Subscribed Users"
        multiple
        saAutomatedSelector="well-creation__subscribed-users"
      >
        <mat-option>
          <ngx-mat-select-search
            [placeholderLabel]="'Subscribed Users'"
            [noEntriesFoundLabel]="'No User found'"
            [formControl]="filterUser"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="let user of filteredUsers$ | async; trackBy: filteredUsers$ | trackByKey: 'id'"
          [value]="user.id"
        >
          <span>{{ user.name }}</span>
        </mat-option>
      </mat-select>
      <mat-hint>Select which users will receive notifications when this PO is nearing or over capacity. </mat-hint>
    </mat-form-field>

    <mat-form-field *ngIf="isGroupedAccountUser$ | async" class="form-field" style="margin-top: 24px;">
      <mat-label>Permitted Fracs (leave blank for all)</mat-label>
      <mat-select formControlName="permittedFracIds" multiple>
        <mat-option *ngFor="let frac of fracList$ | async; trackBy: trackById" [value]="frac.lmoFracSummary.id">{{
          frac.lmoFracSummary.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <sa-network-active-button [active]="submitting$$ | async">
      <button type="submit" mat-raised-button color="primary" saAutomatedSelector="fcpo_add__save_and_use">
        Save and Use Purchase Order
      </button>
    </sa-network-active-button>
  </form>
</div>

<ng-template #newPurchaseOrder>
  <form (ngSubmit)="createPo()" class="new-po-form">
    <mat-form-field class="form-field">
      <input
        #newContractName
        matInput
        placeholder="Purchase Order Name"
        [formControl]="newContractForm"
        autocomplete="off"
      />
    </mat-form-field>
    <button type="submit" color="primary" mat-raised-button [disabled]="newContractForm.invalid">
      Create New Purchase Order
    </button>
    <button type="button" color="warn" mat-raised-button [mat-dialog-close]="false">
      Cancel
    </button>
  </form>
</ng-template>

<ng-template #defaultLoadWeightWarning>
  <div mat-dialog-title>
    Confirm Default Load Weight
  </div>
  <div mat-dialog-content>
    You have entered a default load weight
    <span class="font-semibold">({{ nonPoDataForm.get('defaultLoadWeight').value | number }} lbs)</span> which is less
    than half of the expected load weight, are you sure you wish to proceed?
  </div>
  <div mat-dialog-actions class="flex justify-between">
    <button mat-stroked-button [matDialogClose]="false">Go Back</button>
    <button mat-raised-button color="warn" [matDialogClose]="true">Save Anyway</button>
  </div>
</ng-template>

<ng-template #isSupplementalMesh>
  Mesh – Supplemental
</ng-template>
